export const SHOW_MICROTREND_OVERLAY = 'showMicrotrendOverlay'
export const HIDE_MICROTREND_OVERLAY = 'hideMicrotrendOverlay'
export const SHOW_SNACKBAR = 'showSnackbar'
export const HIDE_SNACKBAR = 'hideSnackbar'
export const SET_INSIGHTS_UPDATES_SEEN = 'SET_INSIGHTS_UPDATES_SEEN'
export const SET_LAST_FEATURE_UPDATE = 'SET_LAST_FEATURE_UPDATE'
export const DISABLE_FEATURE_UPDATES = 'DISABLE_FEATURE_UPDATES'
